module.exports = __webpack_public_path__ + "img/d201109-2.0e77d7da.jpg";